import React, { useState } from "react";
import { Transition } from "@headlessui/react";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const Modal = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  const image = props.image ? getImage(props.image) : props.originalImage;

  const closeModal = () => {
    setIsOpen(false);
  };

  const openModal = () => {
    setIsOpen(true);
  };

  return (
    <div>
      <div className={props.className} onClick={openModal}>
        {typeof image === "string" ? (
          <img
            className="tw-rounded-t-md tw-h-full tw-relative tw-transition tw-opacity-100"
            height={300}
            width={400}
            style={{
              objectFit: "cover",
            }}
            src={image}
            alt=""
          />
        ) : (
          <GatsbyImage
            image={image}
            alt=""
            className="tw-rounded-t-md tw-relative tw-transition tw-opacity-100"
          />
        )}
        <div className="tw-absolute tw-inset-0 tw-top-0 tw-transition tw-left-0 tw-flex tw-justify-center tw-items-center tw-flex-col tw-px-8 tw-space-y-4 tw-text-center tw-opacity-0 tw-bg-enmu-green hover:tw-opacity-80 tw-rounded-md">
          <p>Delivery: {props.delivery}</p>
        </div>
        <p
          style={{ marginBottom: 0 }}
          className="tw-p-1 tw-my-auto tw-px-2 tw-rounded-b-md tw-bg-enmu-green tw-justify-self-center"
        >
          {props.degree}
        </p>
      </div>
      <Transition
        show={isOpen}
        enter="tw-ease-out tw-transition tw-z-50 tw-relative tw-duration-300"
        enterFrom="tw-opacity-0 tw-z-50"
        enterTo="tw-opacity-100 tw-z-50"
        leave="tw-ease-in tw-duration-200 tw-relative tw-z-50"
        leaveFrom="tw-opacity-100"
        leaveTo="tw-opacity-0"
      >
        <div
          className={`tw-transiton tw-inset-0 tw-fixed tw-overflow-y-auto`}
          style={{ zIndex: 100000 }}
        >
          <div className="tw-flex tw-items-end tw-justify-center tw-min-h-screen tw-pt-4 tw-px-4 tw-pb-20 tw-text-center sm:tw-block sm:tw-p-0">
            <div
              className="tw-fixed tw-inset-0 tw-transition-opacity"
              aria-hidden="true"
            >
              <div
                className="tw-absolute tw-inset-0 tw-bg-gray-500 tw-bg-opacity-75"
                onClick={closeModal}
              ></div>
            </div>
            <Transition
              show={isOpen}
              enter="tw-ease-out tw-duration-300"
              enterFrom="tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95"
              enterTo="tw-opacity-100 tw-translate-y-0 sm:tw-scale-100"
              leave="tw-ease-in tw-duration-200"
              leaveFrom="tw-opacity-100 tw-translate-y-0 sm:tw-scale-100"
              leaveTo="tw-opacity-0 tw-translate-y-4 sm:tw-translate-y-0 sm:tw-scale-95"
            >
              <span
                className="tw-inline-block tw-align-middle tw-h-screen"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <div
                className="modal-block tw-relative tw-inline-block tw-bg-white tw-rounded-lg tw-px-4 tw-pt-5 tw-pb-4 tw-text-left tw-overflow-hidden tw-shadow-xl tw-transform tw-transition-all sm:tw-my-8 tw-align-middle sm:tw-max-w-2xl sm:tw-w-full sm:tw-p-6"
                role="dialog"
                aria-modal="true"
                aria-labelledby="modal-headline"
              >
                <button
                  onClick={closeModal}
                  className="text-3xl tw-cursor-pointer close-modal focus:tw-outline-none tw-absolute tw-top-0 tw-right-0 tw-font-bold tw-m-1 sm:tw-m-5"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="none"
                    className="tw-w-6 sm:tw-w-8"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                  </svg>
                </button>
                <h2 className="modal-header" id="modal-headline">
                  {props.header}
                </h2>
                <div className="tw-mt-2 modal-body tw-flex tw-flex-col tw-items-center">
                  {props.children}
                </div>
              </div>
            </Transition>
          </div>
        </div>
      </Transition>
    </div>
  );
};

export default Modal;
